// extracted by mini-css-extract-plugin
export default {"iframeScrollWrapper":"iframeScrollWrapper-31VrO","iframeContent":"iframeContent-peaDj","splashScreen":"splashScreen-3g_J3","loadingWrapper":"loadingWrapper-3vf-N"};